import AuthShowcasePanel from "./AuthShowcasePanel";
import DemoPeek from "./DemoPeek";

/**
 * Split-screen shell for the auth flow: a quiet form column on the
 * app background, and the ink showcase panel on large screens. The
 * form itself is passed as children.
 */
export default function AuthLayout({ children }) {
  return (
    <div className="flex min-h-[100dvh] bg-vaulzo-bg text-vaulzo-ink">
      {/* Form column */}
      <div className="flex min-h-[100dvh] flex-1 flex-col">
        <header className="px-8 pt-7">
          {/* Single click goes home; double-click opens the demo peek */}
          <DemoPeek />
        </header>

        <main className="flex flex-1 items-center justify-center px-6 pb-16 pt-8">
          <div className="w-full max-w-[360px]">{children}</div>
        </main>
      </div>

      {/* Product showcase (desktop only) */}
      <div className="hidden w-[45%] lg:block">
        <AuthShowcasePanel />
      </div>
    </div>
  );
}
